export default function LeadTypes({ leadTypes }) {
  const leadTypeArray = Object.entries(leadTypes).map(([type, count]) => ({
    type,
    count,
  }));

  return (
    <div className="bg-white rounded-2xl p-4 shadow-custom">
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-medium">Types of Leads</h2>
        {/* <button className="text-xs bg-black/10 px-3 py-1 rounded-full">
          View Details
        </button> */}
      </div>
      <div className="space-y-4">
        {leadTypeArray?.map((lead, index) => (
          <div key={index} className="space-y-2">
            <div className="flex justify-between items-center">
              <span>{lead.type}</span>
              <span>{lead.count}</span>
            </div>
            <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
              <div
                className="h-full bg-[#87CA60] rounded-full"
                style={{
                  width: `${(Number(lead?.count) / 5) * 100}%`,
                }}
              />
            </div>
          </div>
        ))}
        {leadTypeArray.length === 0 && <p className="text-red-500 text-center py-4">No data available</p>}
      </div>
    </div>
  );
}
